import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import React, { Component } from 'react';
import { googleMapsApiKey } from '../../../assets/const';
import { styles as mapStyles } from './Map.styles';

export class MapContainer extends Component {

  render() {
    return (
      <Map
        google={this.props.google}
        initialCenter={{
          lat: this.props.lat,
          lng: this.props.lng
        }}
        center={{
          lat: this.props.lat,
          lng: this.props.lng
        }}
        zoom={14}
        styles={mapStyles}
        containerStyle={{position: 'static'}}
      >
        <Marker
          icon={{
            url: require('./../../../assets/img/placeholder.svg'),
            scaledSize: new this.props.google.maps.Size(50, 50)
          }}
          position={{
            lat: this.props.lat,
            lng: this.props.lng
          }}
        />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (googleMapsApiKey)
})(MapContainer);


// WEBPACK FOOTER //
// ./src/views/QxQFacilityShowPage/Partials/MapContainer.js